<template>
  <div style="width: 100%">
    <v-row align="center" style="max-height: 56px">
      <v-col cols="auto">
        <div class="title text--secondary text-uppercase">
          {{ $t("management.toolCheckResults.titleLong") }}
        </div>
      </v-col>
      <v-col class="text-right">
        <v-btn
          color="primary"
          class="white--text"
          :loading="loading || this.$apollo.loading"
          @click="openNewResultDialog([], null)"
          v-if="role('admin', 'safetyRepresentative')"
        >
          {{ $t("management.toolCheckResults.addNew") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
      :items="toolCheckResults"
      :headers="headers"
      class="safety-elevation-3 table-striped"
      :loading="loading || $apollo.loading"
      :footer-props="{
        'items-per-page-text': `${$t('employees.footer.itemsPerPage')}`,
        'items-per-page-all-text': `${$t('employees.footer.all')}`,
      }"
    >
      <template v-slot:[`item.name`]="{ item }">
        <a
          v-if="role('admin', 'safetyRepresentative')"
          href="#"
          @click="changeResultTranslation(item.locales, item.id)"
        >
          {{ item.name }}
        </a>
        <span v-else>{{ item.name }}</span>
      </template>

      <template v-slot:[`item.isPositive`]="{ item }">
        <v-chip
          :color="item.isPositive ? 'green lighten-4' : 'deep-orange lighten-4'"
          :class="item.isPositive ? 'success--text' : 'error--text'"
          class="text--darken-1 text-uppercase"
          small
        >
          {{
            $t(
              `management.toolCheckResults.${
                item.isPositive ? "positive" : "negative"
              }`
            )
          }}
        </v-chip>
        <v-btn icon text @click="toggleIsPositive(item.id)" class="ml-2">
          <v-icon>mdi-swap-horizontal</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <upsert-translation
      v-if="translationDialog"
      :dialogTitle="translationDialog.dialogTitle"
      :id="translationDialog.id"
      :translation="translationDialog.translation"
      :show="translationDialog.show"
      :loading="loading || this.$apollo.loading"
      @hide="translationDialog = null"
      @add="saveResult(translationDialog.id, $event)"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import UpsertTranslation from "@/components/management/component/UpsertTranslation.vue";

import ToolCheckResultsWithLocalesQuery from "@/graphql/queries/tools/ToolCheckResultsWithLocales.gql";
import CreateToolCheckResultMutation from "@/graphql/mutation/tools/CreateToolCheckResult.gql";
import UpdateToolCheckResultMutation from "@/graphql/mutation/tools/UpdateToolCheckResult.gql";
import ToggleResultIsPositiveMutation from "@/graphql/mutation/tools/ToggleResultIsPositive.gql";

export default {
  components: {
    UpsertTranslation,
  },
  data() {
    return {
      translationDialog: null,
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["role"]),
    headers() {
      return [
        {
          text: "ID",
          value: "id",
          class: "text-uppercase subheading text-truncate",
          sortable: false,
        },
        {
          text: this.$i18n.t("management.toolCheckResults.name"),
          value: "name",
          class: "text-uppercase subheading text-truncate",
          sortable: false,
        },
        {
          text: "Tüüp",
          value: "isPositive",
          class: "text-uppercase subheading text-truncate",
          sortable: false,
        },
      ];
    },
  },
  methods: {
    changeResultTranslation(translation, id) {
      this.translationDialog = {
        show: true,
        translation,
        id,
        allTranslations: [],
        dialogTitle: this.$i18n.t("management.toolCheckResults.change"),
      };
    },
    openNewResultDialog(translation, id) {
      this.translationDialog = {
        show: true,
        translation,
        id,
        allTranslations: [],
        dialogTitle: this.$i18n.t("management.toolCheckResults.addNew"),
      };
    },
    saveResult(id, translations) {
      const locales = translations.map(({ language, text }) => ({
        language,
        text,
      }));

      const mutation = id
        ? UpdateToolCheckResultMutation
        : CreateToolCheckResultMutation;

      this.$apollo
        .mutate({
          mutation: mutation,
          variables: id ? { id, locales } : { locales },
        })
        .then((res) => {
          if (id) {
            let updatedResult = this.toolCheckResults.find((m) => m.id == id);
            if (updatedResult) {
              Object.assign(updatedResult, res.data.toolCheckResult);
            }
          } else {
            this.toolCheckResults.push(res.data.toolCheckResult);
          }
        })
        .catch((err) => {
          this.$store.commit("push_global_message", {
            text: err,
            color: "error",
          });
        });
    },
    toggleIsPositive(id) {
      this.$apollo
        .mutate({
          mutation: ToggleResultIsPositiveMutation,
          variables: { id },
        })
        .then((res) => {
          const updatedResult = this.toolCheckResults.find(
            (result) => result.id === id
          );
          if (updatedResult) {
            updatedResult.isPositive = res.data.toolCheckResult.isPositive;
          }
        })
        .catch((err) => {
          this.$store.commit("push_global_message", {
            text: err,
            color: "error",
          });
        });
    },
  },
  apollo: {
    toolCheckResults: {
      query: ToolCheckResultsWithLocalesQuery,
    },
  },
};
</script>
